import { format } from 'date-fns'
import { object, func } from 'prop-types'
import { Fragment } from 'react'
import { kuiperClassNames, renderIcon, Toast } from '@opallabs/kuiper'
import './styles.scss'

const MomentDropToast = ({ dropData, onClose, onUndo }) => {
  const isOpen = dropData && dropData.isActive
  const fromDate = dropData && format(dropData.movedFrom, 'EEE, MMM dd, yyyy')
  const toDate = dropData && format(dropData.movedTo, 'EEE, MMM dd, yyyy')

  return (
    <Toast
      actionRequired={false}
      animationDirection="down"
      className={kuiperClassNames('moment-drop-toast')}
      onClose={onClose}
      isOpen={isOpen}
      centerChildren={
        <div className={kuiperClassNames('toast-message')}>
          <p>
            {' '}
            moved moment from
            <span className={kuiperClassNames('emphasize')}> {fromDate} </span>
            to
            <span className={kuiperClassNames('emphasize')}> {toDate}.</span>
          </p>
        </div>
      }
      rightChildren={
        /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
        <Fragment>
          <div className={kuiperClassNames('button-wrapper')}>
            <button
              onClick={onUndo}
              id="undo-button"
              type="button"
              className={kuiperClassNames('button')}
            >
              undo move
            </button>
          </div>
          <div
            className={kuiperClassNames('toast-icon-wrapper')}
            onClick={onClose}
          >
            {renderIcon('close-lg', {
              style: { color: '#fff', height: 11, width: 11 },
              ariaLabel: 'Dismiss',
              ariaMode: 'presentational',
            })}
          </div>
        </Fragment>
        /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
      }
    />
  )
}

MomentDropToast.propTypes = {
  dropData: object,
  onClose: func,
  onUndo: func,
}

export default MomentDropToast
